<!-- Sticky Tabs -->
<div class="component-wrapper">
  <div class="tabs-sticky">
    <div class="flex justify-center items-start px-5 py-5 pb-3 flex-col w-full">
      <div
        class="flex flex-nowrap items-center lg:items-end justify-between border-b border-b-gray-200 dark:border-b-coal-100 gap-6 mb-3 lg:mb-10"
      >
        <div class="grid">
          <div class="scrollable-x-auto">
            <div class="menu gap-3" data-menu="true">
              <!-- Tabs -->
              <div
                [ngClass]="{ here: activeTab === 'organization' }"
                (click)="setActiveTab('organization')"
                class="menu-item border-b-2 border-b-transparent menu-item-active:border-b-primary menu-item-here:border-b-primary"
              >
                <div class="menu-link gap-1.5 pb-2 lg:pb-4 px-2" tabindex="0">
                  <span
                    class="menu-title text-nowrap font-medium text-sm text-gray-700 menu-item-active:text-primary menu-item-active:font-semibold menu-item-here:text-primary menu-item-here:font-semibold menu-item-show:text-primary menu-link-hover:text-primary"
                    >Organization Information</span
                  >
                </div>
              </div>

              <div
                [ngClass]="{ here: activeTab === 'business-unit' }"
                (click)="setActiveTab('business-unit')"
                class="menu-item border-b-2 border-b-transparent menu-item-active:border-b-primary menu-item-here:border-b-primary"
              >
                <div class="menu-link gap-1.5 pb-2 lg:pb-4 px-2" tabindex="0">
                  <span
                    class="menu-title text-nowrap font-medium text-sm text-gray-700 menu-item-active:text-primary menu-item-active:font-semibold menu-item-here:text-primary menu-item-here:font-semibold menu-item-show:text-primary menu-link-hover:text-primary"
                    >Business Unit</span
                  >
                </div>
              </div>

              <div
                [ngClass]="{ here: activeTab === 'location' }"
                (click)="setActiveTab('location')"
                class="menu-item border-b-2 border-b-transparent menu-item-active:border-b-primary menu-item-here:border-b-primary"
              >
                <div class="menu-link gap-1.5 pb-2 lg:pb-4 px-2" tabindex="0">
                  <span
                    class="menu-title text-nowrap font-medium text-sm text-gray-700 menu-item-active:text-primary menu-item-active:font-semibold menu-item-here:text-primary menu-item-here:font-semibold menu-item-show:text-primary menu-link-hover:text-primary"
                    >Location</span
                  >
                </div>
              </div>

              <div
                [ngClass]="{ here: activeTab === 'employee' }"
                (click)="setActiveTab('employee')"
                class="menu-item border-b-2 menu-item-active border-b-transparent menu-item-here:border-b-primary menu-item-active:border-b-primary"
              >
                <a class="menu-link gap-1.5 pb-2 lg:pb-4 px-2" tabindex="0">
                  <span
                    class="menu-title text-nowrap font-medium text-sm text-gray-700 menu-item-active:text-primary menu-item-active:font-semibold menu-item-here:text-primary menu-item-here:font-semibold menu-item-show:text-primary menu-link-hover:text-primary"
                    >Employees</span
                  >
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Scrollable Content -->
  <div class="content-scroll">
    <div class="w-full px-5">
      <div *ngIf="activeTab === 'organization'">
        <div
          class="border border-gray-600 rounded-lg px-8 py-4 bg-white dark:bg-coal-700"
        >
          <app-form-render
            [disableFields]="disableFields"
            [nodeId]="nodeId"
            [recordID]="recordId"
            [isBtnShow]="isBtnShow"
          ></app-form-render>
        </div>
      </div>

      <div *ngIf="activeTab === 'business-unit'">
        <div class="rounded-xl border bg-white dark:bg-coal-700">
          <div
            class="headerSticky sticky z-20 bg-white rounded-t-xl border-b border-gray-200 dark:bg-coal-700"
          >
            <div
              class="flex flex-wrap justify-between items-center px-3 pt-3 pb-3"
            >
              <div class="flex flex-col col-md-3 col-sm-12">
                <label class="input input-sm sm:w-auto flex items-center gap-2">
                  <i class="ki-filled ki-magnifier"></i>
                  <input
                    #search
                    placeholder="Search "
                    type="text"
                    [value]="searchInput || ''"
                    (keyup)="onKeyUpSearch(search.value)"
                  />
                  <button
                    *ngIf="search.value"
                    type="button"
                    class="clear-btn text-xl"
                    (click)="clearSearch(search)"
                  >
                    ×
                  </button>
                </label>
              </div>

              <div class="flex col-md-7 col-sm-12 gap-2.5 justify-end">
                <div
                  class="flex flex-row flex-wrap sm:flex-nowrap gap-2 sm:gap-4 items-start"
                >
                  <button
                    class="btn btn-sm btn-primary btn-brand-primary"
                    (click)="openModal('business-unit')"
                  >
                    <i class="ki-filled ki-plus-squared"></i>
                    Add
                  </button>
                </div>
              </div>
            </div>
          </div>
          <app-card-type-ten #businessUnits></app-card-type-ten>
        </div>
      </div>

      <div *ngIf="activeTab === 'location'">
        <div class="rounded-xl border bg-white dark:bg-coal-700">
          <div
            class="headerSticky sticky z-20 bg-white rounded-t-xl border-b border-gray-200 dark:bg-coal-700"
          >
            <div
              class="flex flex-wrap justify-between items-center px-3 pt-3 pb-3"
            >
              <div class="flex flex-col col-md-3 col-sm-12">
                <label class="input input-sm sm:w-auto flex items-center gap-2">
                  <i class="ki-filled ki-magnifier"></i>
                  <input
                    #search
                    placeholder="Search "
                    type="text"
                    [value]="searchInputs || ''"
                    (keyup)="onKeyUpSearchs(search.value)"
                  />
                  <button
                    *ngIf="search.value"
                    type="button"
                    class="clear-btn text-xl"
                    (click)="clearSearchs(search)"
                  >
                    ×
                  </button>
                </label>
              </div>

              <div class="flex col-md-7 col-sm-12 gap-2.5 justify-end">
                <div
                  class="flex flex-row flex-wrap sm:flex-nowrap gap-2 sm:gap-4 items-start"
                >
                  <button
                    class="btn btn-sm btn-primary btn-brand-primary"
                    (click)="openModal('location')"
                  >
                    <i class="ki-filled ki-plus-squared"></i>
                    Add
                  </button>
                </div>
              </div>
            </div>
          </div>
          <app-location-card #locations></app-location-card>
        </div>
      </div>

      <div *ngIf="activeTab === 'employee'">
        <app-form-render
          [nodeId]="'68c3ea0a0f615ee795762f89'"
          [isBtnShow]="isBtnShow"
        ></app-form-render>
      </div>
    </div>
  </div>
</div>
<div
  class="modal"
  data-modal="true"
  data-modal-disable-scroll="false"
  id="open_modal"
>
  <div class="modal-content w-full max-w-[600px] bg-white dark:bg-coal-500">
    <div class="modal-header pr-2.5">
      <span class="font-semibold text-base ms-2 card-title">{{
        modalTitle
      }}</span>
    </div>
    <div class="modal-body grid gap-5 px-0">
      <app-modal-renderer
        *ngIf="activeModalContext"
        [nodeId]="activeModalContext?.nodeId"
        (header)="setModalTitle($event)"
        (formSaved)="onModalFormSaved($event, 'add')"
        (closeModal)="closeModal()"
        [recordIDs]="activeModalContext?.recordID"
        [activeModalContext]="activeModalContext"
      ></app-modal-renderer>
    </div>
  </div>
</div>
